/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Gikomero 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */

module.exports = {
  "Gasagara": [
    "Bwimiyange",
    "Bwingeyo",
    "Gasagara",
    "Rugwiza"
  ],
  "Gicaca": [
    "Ntaganzwa",
    "Nyagasozi",
    "Nyagisozi",
    "Ruganda"
  ],
  "Kibara": [
    "Gahinga",
    "Gasharu",
    "Kibobo",
    "Nombe"
  ],
  "Munini": [
    "Munini",
    "Mutokerezwa",
    "Rudakabukirwa",
    "Runyinya"
  ],
  "Murambi": [
    "Kimisebeya",
    "Kivugiza",
    "Rugarama",
    "Twina"
  ]
};
